import { render } from "./SuccessMessage.vue?vue&type=template&id=8423e43a&scoped=true"
const script = {}

import "./SuccessMessage.vue?vue&type=style&index=0&id=8423e43a&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8423e43a"]])

export default __exports__